namespace TotalContest {
    jQuery['validator'].addMethod(
        'minfilesize',
        function (value, element, params) {
            return this.optional(element) || (params[1] && params[1] < (element.files[0].size / 1024));
        }
    );

    jQuery['validator'].addMethod(
        'maxfilesize',
        function (value, element, params) {
            return this.optional(element) || (params[1] && params[1] > (element.files[0].size / 1024));
        }
    );

    jQuery['validator'].addMethod(
        'formats',
        function (value, element, params) {
            return this.optional(element) || (params[1] && params[1].indexOf(element.files[0].type) !== -1);
        }
    );

    jQuery(function () {
        var messages = {};
        jQuery.each(window['jqValidationMessages'], function (rule, message) {
            messages[rule] = function (validation, element) {
                return jQuery['validator'].format(
                    message
                        .replace('{{label}}', element.type === 'file' ? '' : jQuery(element).siblings('label').text())
                        .replace('%d', '{0}')
                        .replace('%s', '{0}'),
                    validation
                );
            };
        });

        jQuery.extend(jQuery['validator'].messages, messages);
    });
}